// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TK-1","questions":"styles_questions__2-xPJ","footer":"styles_footer__3zbtU"};